import Configure from './configure';
import Reservations from './reservations';

const DHCP = [
    Configure,
    Reservations,
];

export default DHCP;